import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7165272c")

_pushScopeId("data-v-7165272c")
const _hoisted_1 = {
  ref: "signUpHolder",
  class: "campaign-sign-up"
}
const _hoisted_2 = { class: "overlay-holder" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "overlay" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: "overlay-bg",
      style: _ctx.backgroundStyle
    }, null, 4),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_router_view, { class: "page-content" })
      ])
    ], 512)
  ], 64))
})